import Decimal from 'decimal.js';

// The total cost of a cut and edge order

export const getCutAndEdgeOrderTotal = (cost: number, taxPercent : number, deliveryCharge = 0) : string => {

    const taxGroup = new Decimal(cost).div(100).mul(taxPercent);
    return new Decimal(cost).add(taxGroup).add(deliveryCharge).toFixed(2);
}